import { type FileStatusIconSize } from '@air/feature-file-status/ui';

export const getTaskPaneFileStatusIconSize = (ui2026: boolean): FileStatusIconSize => (ui2026 ? 'compact' : 'default');
